import { TableClass } from '../../../world/spa/libs/classes';

export default {
	worldEventType() {
		return new TableClass({
			1: {
				it: "Lavoro",
				en: "Work"
			},
			2: {
				it: "Viaggio",
				en: "Trip"
			},
			3: {
				it: "Notturno",
				en: "Night"
			}
		});
	},
	eventPermission() {
		return new TableClass({
			1: {
				it: "Invitato",
				en: "Guest"
			},
			2: {
				it: "Amministratore",
				en: "Admin"
			}
		});
	},
	inviteStatus() {
		return new TableClass({
			1: {
				it: "In attesa",
				en: "Waiting"
			},
			2: {
				it: "Parteciperà",
				en: "Will join"
			},
			3: {
				it: "Non parteciperà",
				en: "Won't join"
			},
			4: {
				it: "Forse parteciperà",
				en: "Will maybe join"
			}
		});
	},
	eventStatus() {
		return new TableClass({
			1: {
				it: "Confermato",
				en: "Confirmed"
			},
			2: {
				it: "Provvisorio",
				en: "Provisional"
			}
		});
	}
}
